import { jsx as _jsx } from "react/jsx-runtime";
import { withBaseIcon } from '../src/Icons.utils';
export const MenuLine = (props) => withBaseIcon(_jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", role: "img", children: _jsx("path", { d: "M3 6H21M3 12H21M3 18H21", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }) }), props);
MenuLine.iconName = 'menu';
MenuLine.displayName = 'MenuLine';
export default MenuLine;
